import { render, staticRenderFns } from "./relatedProductsCoal.vue?vue&type=template&id=2cfd2601&scoped=true&"
import script from "./relatedProductsCoal.vue?vue&type=script&lang=js&"
export * from "./relatedProductsCoal.vue?vue&type=script&lang=js&"
import style0 from "./relatedProductsCoal.vue?vue&type=style&index=0&id=2cfd2601&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd2601",
  null
  
)

export default component.exports